<template>
  <div
    class="modal fade createticket-pop"
    id="createTicket"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="pop-close">
          <button data-bs-dismiss="modal" id="createTicketPopClose">
            <img
              src="@/assets/lems-v1/images/close-black-icon.svg"
              alt=""
              width="100%"
            />
          </button>
        </div>
        <div class="createticket-top">
          <i
            ><img src="@/assets/lems-v1/images/create-ticket-icon.png" alt=""
          /></i>
          <h1>
            {{ constants.CREATE_TICKET_TEXT }}
          </h1>
        </div>
        <form>
          <div class="createticket-btm">
            <div class="createticket-btm-l">
              <div class="v1-input-field">
                <label>
                  {{ constants.SELECT_PROJECT_LABEL }}
                  <span>*</span>
                </label>
                <select
                  id="createTicketSelectProSelectBox"
                  class="custom-select-box"
                >
                  <option>Select Project</option>
                </select>
              </div>
              <div class="v1-input-field">
                <label>
                  {{ constants.SUMMERY_LABEL }}
                  <span>*</span>
                </label>
                <textarea
                  id="createTicketSummaryInput"
                  class="height-80"
                  placeholder="Enter the ticket summery "
                ></textarea>
                <span class="count-info">(255)</span>
                <i class="info-txt">
                  You must specify the summary to this issue.
                </i>
              </div>

              <div class="v1-input-field">
                <label>
                  {{ constants.TICKET_TYPE_LABEL }}
                  <span>*</span>
                </label>
                <select
                  class="custom-select-box"
                  id="createTicketSelectTicketTypeSelectBox"
                >
                  <option>Ticket Type</option>
                  <option>Technical task</option>
                </select>
              </div>
              <div class="v1-input-field">
                <label> {{ constants.DESCRIPTION_LABEL }}</label>
                <textarea
                  id="createTicketDescriptionInput"
                  class="height-80"
                  placeholder="Description"
                ></textarea>
              </div>
            </div>
            <div class="createticket-btm-r">
              <div>
                <div class="drag-drop-files">
                  <i><img src="@/assets/lems-v1/images/upload.svg" alt="" /></i>
                  <h2>
                    {{ constants.DRAG_AND_DROP_FILES_TEXT }}
                  </h2>
                </div>
                <div class="or">
                  {{ constants.OR_TEXT }}
                </div>
                <div class="file-upload">
                  <span class="v1-button-outline">
                    {{ constants.UPLOAD_LABEL }}
                  </span>
                  <input id="createTicketUploadInput" type="file" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-submit">
            <button class="v1-button-outline" id="createTicketBtn">
              {{ constants.CREATE_BUTTON }}
            </button>
            <button class="v1-button-outline-black" id="canceTicketlBtn">
              {{ constants.CANCEL_BUTTON }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "CreateTicketPopup",
  data() {
    return {
      constants,
    };
  },
});
</script>
